import { CopyOutlined } from "@ant-design/icons";
import { message } from "antd";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";

export function CopyableText(props: { text: string }) {
  const { t } = useTranslation();
  const { text } = props;

  const showSuccessMessage = () => {
    message.success(t("copy-success"));
  };

  const showErrorMessage = () => {
    message.error(t("copy-failed"));
  };

  const copy = useCallback(
    async (e: React.MouseEvent) => {
      e.preventDefault();

      try {
        // Try modern copy API first
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(text);
          showSuccessMessage();
          return;
        }

        // Fallback to legacy method
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.setAttribute("readonly", "");
        textArea.style.position = "absolute";
        textArea.style.left = "-9999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        const successful = document.execCommand("copy");
        document.body.removeChild(textArea);

        if (successful) {
          showSuccessMessage();
        } else {
          throw new Error("Copy command failed");
        }
      } catch (error) {
        console.error("Failed to copy text:", error);
        showErrorMessage();
      }
    },
    [text, t]
  );

  if (!props.text) {
    return <></>;
  }
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "0.5em" }}>
      <span className="selectable" style={{ flex: 1 }}>{text}</span>
      <CopyOutlined
      className="icon"
      onClick={copy}
      title={t("copy-to-clipboard")}
      />
    </div>
  );
}
